'use client'

import { User } from 'lucide-react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Card, CardContent } from '@/components/ui/card'

interface ProfileCardProps {
  name: string
  occupation: string
  image_url: string
}

export function ProfileCardWebinar({
  name,
  occupation,
  image_url,
}: Readonly<ProfileCardProps>) {
  return (
    <Card className="overflow-hidden bg-white shadow-xs transition-shadow hover:shadow-md">
      <CardContent className="p-0">
        <div className="flex items-center gap-4">
          <Avatar className="h-[196px] w-[200px] rounded-lg">
            <AvatarImage
              alt={`${name} profile picture`}
              className="object-cover"
              onError={e => {
                console.error('Image load error:', e)
              }}
              src={image_url || '/placeholder.svg'}
            />
            <AvatarFallback className="rounded-lg bg-linear-to-br from-purple-400 to-purple-600 text-white">
              <User className="h-16 w-16" />
            </AvatarFallback>
          </Avatar>
          <div className="min-w-0 flex-1">
            <h3 className="truncate font-semibold text-gray-900 text-xl">
              {name}
            </h3>
            <p className="mt-1 text-gray-600 text-sm">{occupation}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
